import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getPreferences, getPreferenceSecurity, getPreferencesLoading, getPreferencesLoaded, getPreferencesError} from '../selectors';
import {fetchPreferenceSecurity, fetchPreferences} from '../actionCreators';

const useSectors = (forceReload = false) => {
  const sectors = useSelector(getPreferences);
  const security = useSelector(getPreferenceSecurity);
  const loaded = useSelector(getPreferencesLoaded);
  const loading = useSelector(getPreferencesLoading);
  const error = useSelector(getPreferencesError);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loaded || forceReload) dispatch(fetchPreferences());
    dispatch(fetchPreferenceSecurity());
    return () => null;
    // We don't want `loaded` in the dependancies for this function.
    // It can cause an infinite loop, since loaded is a timestamp.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, forceReload]);

  return [sectors, security, loading, error];
};

export default useSectors;
